import { render } from "./screenshot_slider.vue?vue&type=template&id=94208a4e"
import script from "./screenshot_slider.vue?vue&type=script&lang=js"
export * from "./screenshot_slider.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__